export const RESOURCE_TAGS = {
    ALL: 'All',
    FIELD_VISIBILITY_PAYOUTS: 'Field Visibility & Payouts',
    DOCUMENTATION_CLAIMS: 'Documentation & Claims',
    EVALUATING_OPTIONS: 'Evaluating Your Options',
};

export const RESOURCE_HERO = {
    title: "What we've learned running home rehabilitation operations",
    subtitle:
        'Field management, session verification, therapist payouts, and documentation. Published for rehab centre owners and ops heads who are figuring this out without a playbook.',
};

export const RESOURCE_POSTS = [
    {
        slug: 'when-home-therapy-teams-grow-what-breaks-at-scale',
        title: 'When Home Therapy Teams Grow: What Breaks at Scale',
        tag: RESOURCE_TAGS.FIELD_VISIBILITY_PAYOUTS,
        readMinutes: 8,
        excerpt:
            'Every rehab centre hits the same wall at the same point. Not when they hire their twentieth therapist. When they hire their tenth.',
        seoDescription:
            "The systems that hold at 5 therapists don't hold at 15. Here's what breaks first, and what needs to change before it does.",
    },
    {
        slug: 'why-whatsapp-breaks-field-operations-system',
        title: 'Why WhatsApp Breaks as a Field Operations System',
        tag: RESOURCE_TAGS.FIELD_VISIBILITY_PAYOUTS,
        readMinutes: 8,
        excerpt:
            'For home rehab centres managing field teams, WhatsApp stops working at a very predictable point.',
        seoDescription:
            "WhatsApp keeps home therapy operations running until a claim gets rejected or a dispute can't be resolved. Here's what the absence of a structured record actually costs.",
    },
    // {
    //     slug: 'session-verification-payout-cycle-home-rehab',
    //     title: 'How Session Verification Changes Your Payout Cycle',
    //     tag: RESOURCE_TAGS.DOCUMENTATION_CLAIMS,
    //     readMinutes: 8,
    //     excerpt:
    //         'Most home rehab centres calculate payouts from what therapists report. Session verification changes the input. The payout figure comes from what was confirmed, not what was claimed.',
    //     seoDescription:
    //         "When therapist payouts depend on self-reported sessions, every payout cycle is a negotiation. Session verification removes the negotiation entirely. Here's how.",
    // },
    {
        slug: 'payout-disputes-home-rehab-fix',
        title: 'Payout Disputes in Home Rehab: Can Your System Fix Them?',
        tag: RESOURCE_TAGS.DOCUMENTATION_CLAIMS,
        readMinutes: 6,
        excerpt:
            'Most rehab centre owners spend months trying to fix payout disputes by building more trust with their therapists. The disputes keep coming. The problem was never the people.',
        seoDescription:
            "Payout disputes in home rehab aren't caused by dishonest therapists. They're caused by the absence of a verified record. Here's how to tell if your current system can actually fix that.",
    },
    {
        slug: 'why-insurance-claims-rejected-home-rehab',
        title: 'Why Insurance Claims Get Rejected in Home Rehab',
        tag: RESOURCE_TAGS.DOCUMENTATION_CLAIMS,
        readMinutes: 8,
        excerpt:
            "Claim rejections in home rehab aren't caused by careless therapists. They're caused by documentation that was never structured to hold up under scrutiny.",
        seoDescription:
            "Home rehab insurance claims don't get rejected because sessions didn't happen. They get rejected because the documentation wasn't structured to survive insurer review. Here's why reminders don't fix it and what does.",
    },
    {
        slug: 'why-clinic-software-fails-home-visit-teams',
        title: 'Why Clinic Software Fails for Home Visit Teams',
        tag: RESOURCE_TAGS.EVALUATING_OPTIONS,
        readMinutes: 5,
        excerpt:
            "Clinic software tracks what happens inside your facility. It has no concept of a therapist moving between five patient homes in a day. That's not a missing feature — it's a different workflow entirely.",
        seoDescription:
            'Clinic-first software versus home-visit rehabilitation workflows—and why the gap is structural.',
    },
    {
        slug: 'how-to-evaluate-software-field-therapy-teams',
        title: 'How to Evaluate Software for Field-Based Therapy Teams',
        tag: RESOURCE_TAGS.EVALUATING_OPTIONS,
        readMinutes: 7,
        excerpt:
            "Most platforms will show you scheduling and notes. Fewer will show you verified visits, field accountability, and payout accuracy. Here's how to tell the difference before you commit.",
        seoDescription:
            'How to evaluate software for field-based therapy: verified visits, accountability, and payout accuracy before you buy.',
    },
];
